// Tujuan: Redux action untuk PO Analytics — ambil data analitik purchase order per produk + rekomendasi
// Caller: PurchaseOrderPage
// Dependencies: services/poService
// Main Functions: getPOAnalytics, getPORecommendations, resetPO
// Side Effects: HTTP GET /po-analytics, HTTP GET /po-analytics/recommendations

import Swal from "sweetalert2";
import * as Type from "store/actionTypes/po";
import {
  getPOAnalytics as getPOAnalyticsService,
  getPORecommendations as getPORecommendationsService,
  resetPO as resetPOService,
} from "services";

export const getPOAnalytics =
  (filter, params = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: Type.PO_REQUEST });
      const res = await getPOAnalyticsService(filter, params);
      dispatch({
        type: Type.GET_PO_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      Swal.fire("error", err.message, "error");
      dispatch({
        type: Type.GET_PO_ERROR,
        payload: err.message,
      });
    }
  };

export const getPORecommendations =
  (params = "") =>
  async (dispatch) => {
    try {
      dispatch({ type: Type.PO_RECOMMENDATIONS_REQUEST });
      const res = await getPORecommendationsService(params);
      dispatch({
        type: Type.PO_RECOMMENDATIONS_SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: Type.PO_RECOMMENDATIONS_ERROR,
        payload: err.message,
      });
    }
  };

export const resetPO = () => (dispatch) => {
  resetPOService();
  dispatch({ type: Type.PO_RESET });
};
